import type { GetRiskAssessmentResultAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetRiskAssessmentResultAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetRiskAssessmentResultAuditByIdArgs = { id: string };

export const useGetRiskAssessmentResultAuditById = createQueryHook<
  UseGetRiskAssessmentResultAuditByIdArgs,
  GetRiskAssessmentResultAuditByIdResponseRow[],
  AuditLogQueryResult<
    'risk_assessment_result_audit',
    GetRiskAssessmentResultAuditByIdResponseRow
  >
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getRiskAssessmentResultAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    risk_assessment_result_audit: data || [],
  }),
  graphqlDocument: GetRiskAssessmentResultAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
